import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-104">
      <div className="max-w-3xl mx-auto text-center" data-id="element-105">
        <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-106">
          Votre investissement est 100% protégé
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-8 tracking-tight" data-id="element-107">
          Garantie Totale de{' '}
          <span className="italic text-pilates-sage-dark" data-id="element-108">30 Jours</span>
        </h2>

        <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-lg border border-pilates-sage/20 relative" data-id="element-109">
          <div className="bg-gradient-to-br from-pilates-sage to-pilates-sage-dark w-20 h-20 rounded-full flex items-center justify-center shadow-xl mx-auto mb-6" data-id="element-110">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-111" />
          </div>

          <h3 className="font-display text-2xl font-semibold text-pilates-dark mb-4" data-id="element-112">
            Votre argent est 100% protégé
          </h3>
          <p className="text-pilates-slate text-base sm:text-lg leading-relaxed" data-id="element-113">
            Vous avez 30 jours complets pour explorer les 6 livres, appliquer
            les séquences en studio et évaluer les résultats. Si vous n'êtes pas
            pleinement satisfait(e), nous vous remboursons intégralement. Risque
            ZÉRO pour vous, engagement total de notre part.
          </p>
        </div>
      </div>
    </section>;
}